<template>
  <v-container class="ma-0 pa-0" width="100%" height="100%">
    <!-- action card-->
    <v-container class="ma-0 pa-0 d-flex justify-space-between" width="100%">
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-container
          v-if="formula && formula[0].level != 'manual'"
          class="pa-0 ma-0 formula-wrapper"
        >
          <v-container class="pa-0 ma-0 formula-inline">
            <!-- Result part -->
            <v-container class="pa-0 ma-0 d-flex">
              <v-card-text class="pa-0 ma-0 text-body-2"
                >{{ formula[0]?.name }} =</v-card-text
              >
              <v-card-text class="pa-0 ma-0 text-body-2">
                <span class="px-1" v-if="formula[0]?.fixedNumber > 0">
                  {{ formula[0].fixedNumber }}
                </span>
                <span v-if="formula[0]?.fixedNumber > 0">+</span>

                <span class="px-1" v-if="formula[0]?.fixedCoefficient > 1">
                  {{ formula[0].fixedCoefficient }} ×
                </span>
              </v-card-text>
            </v-container>
            <!-- Fraction -->
            <v-container class="pa-0 ma-0 fraction">
              <v-container class="pa-0 ma-0 d-flex">
                <v-card-text
                  v-if="effectiveWorksTitles"
                  class="pa-0 ma-0 text-body-2 numerator"
                >
                  ( {{ effectiveWorksTitles }} ) ×
                </v-card-text>
                <v-card-text
                  v-if="insuranceTaxesTitles"
                  class="pa-0 ma-0 text-body-2 numerator"
                >
                  ( {{ insuranceTaxesTitles }} )
                </v-card-text>
              </v-container>
              <div
                v-if="effectiveWorksTitles || insuranceTaxesTitles"
                class="fraction-line"
              ></div>
              <v-card-text
                v-if="effectiveWorksTitles || insuranceTaxesTitles"
                class="pa-0 ma-0 text-body-2 denominator"
              >
                <span
                  v-if="
                    formula[0]?.denominatorType == 'fixed' &&
                    formula[0]?.denominator != null
                  "
                >
                  {{ formula[0].denominator }}
                </span>
                <span v-else>
                  {{ $t(formula[0]?.denominatorType) }}
                </span>
              </v-card-text>
            </v-container>
          </v-container>
        </v-container>
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-btn
          :loading="loading"
          @click="saveAndReturn()"
          class="ma-0 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("Save and Return") }}
        </v-btn>
      </v-container>
    </v-container>
  </v-container>
</template>
<script>
export default {
  name: "ActionSection",
  props: {
    formula: {
      type: [String, Object, Array],
      default: null,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    loader: {
      deep: true,
      handler(val) {
        this.loading = val;
      },
    },
  },
  components: {},
  computed: {
    effectiveWorksTitles() {
      const arr = this.formula?.[0]?.instanceeffectiveWorksMock || [];
      return arr
        .map((item) => (item.value === 1 ? item.title : `${item.title} × ${item.value}`))
        .join(" + ");
    },
    insuranceTaxesTitles() {
      const arr = this.formula?.[0]?.instanceInsuranceTaxes || [];
      return arr.map((item) => item.title).join(" + ");
    },
  },

  data: () => ({
    loading: false,
  }),
  mounted() {},
  methods: {
    saveAndReturn() {
      this.loading = true;
      this.$emit("loading", true);
      setTimeout(() => {
        this.$emit("click-save-and-return");
      }, 300);
    },
  },
};
</script>
<style scoped>
.formula-wrapper {
  direction: rtl;
  font-family: IRANSans, Arial, sans-serif;
  color: #2c2c2c;
}
.formula-inline {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;
}
.fraction {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
  max-width: 100%;
}
.numerator {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.fraction-line {
  width: 100%;
  height: 1px;
  background-color: #000;
  margin: 4px 0;
}
.denominator {
  font-size: 13px;
  color: #555;
  white-space: nowrap;
}
.formula-result {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}
.main_action {
  width: 100%;
}
.right {
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
</style>
